import { b as ToastContext } from '../../useOrchard-7b9a6b37.js';
export { c as Toast, T as ToastProvider } from '../../useOrchard-7b9a6b37.js';
import * as React from 'react';
import '../../tslib.es6-21effb23.js';
import 'react-dom';
import '../../index-29eed6c4.js';
import 'react-spring';
import '../../countries-66cada71.js';
import './IconButton.js';
import '../../skeleton.module-4f527a2f.js';
import './TextLink.js';
import './Typography.js';
import '../../ResizeObserver-c9aca664.js';
import '../../CircleAlertIcon-4b674f5b.js';
import '../../CloseIcon-a96790fc.js';
import '../../InfoIcon-b656f0ef.js';
import '../../ThemeProvider-030aad7d.js';

function useToast() {
    var context = React.useContext(ToastContext);
    if (!context) {
        throw new Error("useToast must be a child of ToastProvider");
    }
    return context;
}

export { useToast };
